var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup37(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 182.16,
    height: 114.437,
    viewBox: "0 0 182.16 114.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(91.081 -1572.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1003.96,686.236a2.1,2.1,0,0,1-1.62.755H987.71a2.133,2.133,0,0,1-2.12-2.147V655.159h14.081l4.762,29.339a2.128,2.128,0,0,1-.473,1.738",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1134.632,623.52l-.007.111-.178-.132Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1127.584,626.829v.263l-.007-.131Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1134.632,623.52l-.007.111-.178-.132Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1134.632,623.52l-.007.111-.178-.132Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1134.632,623.52l-.007.111-.178-.132Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1006.938,604.3V649.62h-26.5a8.019,8.019,0,0,1-7.981-8.051v-7.083h-3.2a4.179,4.179,0,0,1-2.292-.685,4.251,4.251,0,0,1-1.921-3.565v-6.55a4.251,4.251,0,0,1,1.921-3.565,4.179,4.179,0,0,1,2.292-.685h3.2v-7.083a8.019,8.019,0,0,1,7.981-8.051Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1134.632,623.52l-.007.111-.178-.132Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1127.577,626.961l.007.132v-.264Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M1147.1,624.843c-.034-.367-.083-.72-.138-1.08v-.007a21.1,21.1,0,0,0-3.993-9.547,21.074,21.074,0,0,0-9.9-7.263v40.036a21.138,21.138,0,0,0,9.889-7.255,21.163,21.163,0,0,0,2.807-5.047c.24-.616.446-1.253.631-1.9a21.538,21.538,0,0,0,.782-4.887c.014-.312.021-.623.021-.935q0-1.07-.1-2.118m-12.476-1.212-.178-.131.185.02Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M1127.584,626.829v.263l-.007-.131Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M1134.632,623.52l-.007.111-.178-.132Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M1127.584,626.829v.263l-.007-.131Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M1127.584,579.684V626.83l-.007.131.007.132v47.146a7.068,7.068,0,0,1-9.36,6.736l-81.963-28.5V601.45l81.963-28.5a7.07,7.07,0,0,1,9.36,6.736",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1127.584,626.829v.263l-.007-.131Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1030.771,598.452V655.47a5.1,5.1,0,0,1-.082.921,5.277,5.277,0,0,1-5.175,4.389h-7.823a5.288,5.288,0,0,1-5.263-5.31V598.452a5.282,5.282,0,0,1,5.263-5.3h7.823a5.265,5.265,0,0,1,5.175,4.389,5.015,5.015,0,0,1,.082.914",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup37);
export default __webpack_public_path__ + "static/media/Group 37.a8729129eaffe2cebfee569addefe51b.svg";
export { ForwardRef as ReactComponent };